// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent_2/work/861f9e7e0cb825c7/node_modules/core-js/modules/_enum-bug-keys.js
// module id = a/Sk
// module chunks = 15